import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useAuth } from "./context/AuthContext";
import DashboardLayout from "./layout/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import theme from "./theme";
import AdminColegiados from "./components/Colegiado/AdminColegiados";
import ColegiadoForm from "./components/Colegiado/ColegiadoForm";
import CursosExistentes from "./components/Cursos/CursosExistentes";
import CursosInscripcion from "./components/Cursos/CursosInscripcion";
import Documentos from "./components/Documentos/Documentos";
import Citas from "./components/Citas/Citas";
import Pagos from "./components/Pagos/Pagos";
import HistoricoCambiosMios from "./components/HistoricoCambios/HistoricoCambiosMios";
import Avisos from "./components/Avisos/Avisos";
import AltaNuevoIngreso from "./components/Solicitudes/AltaNuevoIngreso";
import AdminDocumentos from "./components/Admin/AdminDocumentos";
import SubvencionesAdmin from "./components/Admin/SubvencionesAdmin";
import SubvencionesPublicas from "./components/Colegiado/SubvencionesPublicas";
import HistoricoCambiosAdmin from "./components/Admin/HistoricoCambiosAdmin";
import CatalogosAdmin from "./components/Admin/CatalogosAdmin";
import CursosAdmin from "./components/Admin/CursosAdmin";
import MaestrosAdmin from "./components/Admin/MaestrosAdmin";
import PremiosAdmin from "./components/Admin/PremiosAdmin";
import AgendaAdmin from "./components/Admin/AgendaAdmin";
import CitasAdmin from "./components/Admin/CitasAdmin";
import EmailMasivo from "./components/Admin/EmailMasivo";
import AvisosAdmin from "./components/Admin/AvisosAdmin";
import DocumentosRegistroAdmin from "./components/Admin/DocumentosRegistroAdmin";
import PagosAdmin from "./components/Admin/PagosAdmin"
import AdministradoresAdmin from "./components/Admin/AdministradoresAdmin";
import AdminConfig from "./components/Admin/AdminConfig";
import TramitesAdmin from "./components/Admin/TramitesAdmin";
import TramitesPublicos from "./components/Colegiado/TramitesPublicos";
import NoticiasAdmin from "./components/Admin/NoticiasAdmin";
import Aleatorizador from "./components/Utiles/Aleatorizador";
import RemesasManager from "./components/Admin/RemesasManager";
import EventosAdmin from "./components/Admin/EventosAdmin";
import EventosColegiado from "./components/Colegiado/EventosColegiado";
import ColegiadoRecibos from "./components/Colegiado/ColegiadoRecibos";
import ManualColegiado from "./components/Manual/ManualColegiado";
import ManualAdmin from "./components/Manual/ManualAdmin";
import LandingRedirect from "./LandingRedirect";
import DashboardEntry from "./DashboardEntry";
import ResetPassword from "./components/Colegiado/ResetPassword";

const API_BASE =
  (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim()) ||
  (typeof window !== "undefined" ? window.location.origin.replace("app.", "api.") : "");

const _fetch = window.fetch.bind(window);
window.fetch = (input, init) => {
  let url = typeof input === "string" ? input : input.url;
  if (url.startsWith("http://localhost:8080")) {
    url = url.replace("http://localhost:8080", API_BASE);
  } else if (url.startsWith("https://localhost:8080")) {
    url = url.replace("https://localhost:8080", API_BASE);
  } else if (url.startsWith("http://127.0.0.1:8080")) {
    url = url.replace("http://127.0.0.1:8080", API_BASE);
  } else if (url.startsWith("/")) {
    url = API_BASE + url;
  }
  return _fetch(url, init);
};

function PrivateRoute({ children }) {
  const { usuario, loading } = useAuth();
  if (loading) return null;
  return usuario ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { usuario, loading } = useAuth();
  if (loading) return null;
  return usuario && usuario.rol === "ADMIN" ? children : <Navigate to="/dashboard" />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<LandingRedirect />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <DashboardEntry />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
        <Route
          path="/admin/colegiados"
          element={
            <AdminRoute>
              <DashboardLayout>
                <AdminColegiados />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/subvenciones"
          element={
            <AdminRoute>
              <DashboardLayout>
                <SubvencionesAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/tramites"
          element={
            <AdminRoute>
              <DashboardLayout>
                <TramitesAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/eventos"
          element={
            <AdminRoute>
              <DashboardLayout>
                <EventosAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/historico-cambios"
          element={
            <AdminRoute>
              <DashboardLayout>
                <HistoricoCambiosAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/remesas"
          element={
            <AdminRoute>
              <DashboardLayout>
                <RemesasManager />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/catalogos"
          element={
            <AdminRoute>
              <DashboardLayout>
                <CatalogosAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/cursos"
          element={
            <AdminRoute>
              <DashboardLayout>
                <CursosAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/maestros"
          element={
            <AdminRoute>
              <DashboardLayout>
                <MaestrosAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/agenda"
          element={
            <AdminRoute>
              <DashboardLayout>
                <AgendaAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/noticias"
          element={
            <AdminRoute>
              <DashboardLayout>
                <NoticiasAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/premios"
          element={
            <AdminRoute>
              <DashboardLayout>
                <PremiosAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/citas"
          element={
            <AdminRoute>
              <DashboardLayout>
                <CitasAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/random"
          element={
            <AdminRoute>
              <DashboardLayout>
                <Aleatorizador />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/email"
          element={
            <AdminRoute>
              <DashboardLayout>
                <EmailMasivo />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/avisos"
          element={
            <AdminRoute>
              <DashboardLayout>
                <AvisosAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/registro"
          element={
            <AdminRoute>
              <DashboardLayout>
                <DocumentosRegistroAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/pagos"
          element={
            <AdminRoute>
              <DashboardLayout>
                <PagosAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/administracion"
          element={
            <AdminRoute>
              <DashboardLayout>
                <AdministradoresAdmin />
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin/config"
          element={
            <AdminRoute>
              <DashboardLayout>
                <AdminConfig />
              </DashboardLayout>
            </AdminRoute>
          }
        />

        <Route
          path="/perfil"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <ColegiadoForm modoEdicion={true} />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/subvenciones"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <SubvencionesPublicas />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/tramites"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <TramitesPublicos />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route path="/manual/colegiado" element={<ManualColegiado />} />
        <Route path="/manual/admin" element={<ManualAdmin />} />
        <Route
          path="/perfil"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <ColegiadoForm modoEdicion={true} />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/cursos"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <CursosExistentes />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/inscripciones"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <CursosInscripcion />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/recibos"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <ColegiadoRecibos />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/documentos"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <AdminDocumentos />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/citas"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <Citas />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/pagos"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <Pagos />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/historico"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <HistoricoCambiosMios />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/documentos"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <Documentos />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/eventos"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <EventosColegiado />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/avisos"
          element={
            <PrivateRoute>
              <DashboardLayout>
                <Avisos />
              </DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/alta-nuevo-ingreso"
          element={
            <AltaNuevoIngreso />
          }
        />
        <Route
          path="/remesas"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Remesas / SEPA</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/premios"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Premios</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/especialidades"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Especialidades</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/funciones"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Funciones</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Administración</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/auditoria"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Auditoría</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/importar-xml"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Importar XML</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/correos"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Correos Masivos</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/configuracion"
          element={
            <AdminRoute>
              <DashboardLayout>
                <div>Configuración</div>
              </DashboardLayout>
            </AdminRoute>
          }
        />
        <Route path="*" element={<LandingRedirect />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
